// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"083ad272","496":"36c65bca"}[chunkId] + ".chunk.js";
};